import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { HomeComponent } from './pages/home/home.component';

const routes: Routes = [
    {
        path: MenuItemPath.get(MenuItem.home),
        component: HomeComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class HomeRoutingModule { }
